import type { ChangeEmailInput, ChangePasswordInput, MeResponse, SessionInfo, UpdateProfileInput } from '@brechoflow/contracts';
import { http } from '@/lib/api';

export const accountKeys = { sessions: ['account', 'sessions'] as const };

export const accountApi = {
  updateProfile: (input: UpdateProfileInput) => http.patch<MeResponse>('/auth/profile', input),
  changeEmail: (input: ChangeEmailInput) => http.post<MeResponse>('/auth/change-email', input),
  changePassword: (input: ChangePasswordInput) => http.post<{ ok: true }>('/auth/change-password', input),
  sessions: () => http.get<SessionInfo[]>('/auth/sessions'),
  revokeSession: (id: string) => http.delete<{ ok: true }>(`/auth/sessions/${id}`),
  revokeOthers: () => http.post<{ ok: true }>('/auth/sessions/revoke-others'),
};
